<template>
  <section class="section-shaped">
    <div :class="'shape bg-'+color+' shape-'+color+' shape-skew' + (alt ? '-alt':'-norm')"></div>
    <div class="container shape-container">
      <div class="text-center">
        <div class="h2 text-white text-uppercase">{{ title }}</div>
        <div class="lead text-white w-75 mx-auto">{{ subtitle }}</div>
      </div>
      <div class="row p-sm">
        <div class="card w-100 border-default">
          <div class="card-header bg-default text-light font-weight-bold">Compose Message</div>
          <div class="card-body">
            <div class="d-flex text-default">
              To:&nbsp;&nbsp;
              <input v-model="to" class="no-borders flex-grow-1" disabled>
            </div>
            <hr class="my-3">
            <div class="d-flex flex-wrap text-default">
              Cc:&nbsp;&nbsp;
              <div
                class="mr-2 badge-pill badge-inverse badge-info text-lowercase"
                v-for="(email, idx) in ccList"
                :key="idx"
              >
                {{ email }}
                <span class="pl-2">
                  <font-awesome-icon
                    icon="times"
                    size="1x"
                    @click="cancelEmail(idx)"
                    class="cursor-pointer"
                  ></font-awesome-icon>
                </span>
              </div>
              <input
                v-model="cc"
                placeholder="your@email.address"
                class="no-borders flex-grow-1"
                @change="grabEmail"
                @input="checkEmail"
              >
            </div>
            <hr class="my-3">
            <div class="d-flex flex-wrap">
              <input v-model="subject" placeholder="[Subject]" class="no-borders flex-grow-1">
            </div>
            <hr class="my-3">
            <textarea
              ref="editor"
              v-model="msg"
              @change="resize"
              @input="resize"
              class="w-100 no-borders"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
            ></textarea>
          </div>
          <div class="card-footer">
            <base-button
              v-show="!emailFailed && !emailSent"
              type="primary"
              :disabled="!canSend()"
              @click="sendEmail()"
            >
              <font-awesome-icon
                :icon="isSendingMail ? 'spinner' : 'paper-plane'"
                :spin="isSendingMail"
              ></font-awesome-icon>&nbsp;&nbsp;&nbsp;&nbsp;Send
            </base-button>
            <base-alert type="success" v-show="emailSent">
              <strong>Success!</strong> Your email was successfully sent!
            </base-alert>
            <base-alert type="danger" v-show="emailFailed">
              <strong>Oh No!</strong> There was an error sending your email. We're terribly sorry. Please let us know at
              <b>support@nightmorning.com</b>
            </base-alert>
          </div>
        </div>
      </div>
      <div class="w-75 mx-auto">
        <div class="lead text-center text-white">{{ text }}</div>
      </div>
    </div>
  </section>
</template>
<script>
import { request } from "http";
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "dark"
    },
    alt: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      to: "support@nightmorning.com",
      cc: "",
      ccList: [],
      msg: this.message,
      subject: "",
      emailSent: false,
      emailFailed: false,
      isSendingMail: false
    };
  },
  methods: {
    cancelEmail: function(idx) {
      this.ccList.splice(idx, 1);
      console.log("Clicked: " + idx);
    },
    checkEmail: function() {
      const charLen = this.cc.length;
      if (charLen > 0) {
        const lastChar = this.cc.charAt(charLen - 1);
        if (lastChar === " " || lastChar === ",") {
          this.cc = this.cc.substring(0, this.cc.length - 1);
          this.grabEmail();
        }
      }
    },
    grabEmail: function() {
      if (
        this.cc.length < 6 ||
        this.cc.indexOf("@") === -1 ||
        this.cc.indexOf(".") === -1
      ) {
        return;
      }
      const email = this.cc;
      this.ccList.push(email);
      this.cc = "";
    },
    resize: function() {
      this.$refs.editor.style.height = this.$refs.editor.scrollHeight + "px";
    },
    canSend: function() {
      return (
        // this.subject.length > 0 &&
        // this.ccList.length > 0 &&
        this.message !== this.msg
      );
    },
    sendEmail: function() {
      if (!this.canSend()) {
        return;
      }

      let emails = "";
      this.ccList.forEach(email => {
        emails += email + ",";
      });
      
      this.isSendingMail = true;

      const request = require("request");
      request.post(
        {
          url:
            "https://asia-northeast1-nightmorningdotcom.cloudfunctions.net/api/v1.0/submitcontactform",
          headers: { "content-type": "application/json" },
          json: {
            message: this.msg,
            subject: this.subject,
            emails: emails
          }
        },
        this.processCallback
      );
    },
    processCallback: function(error, response, body) {
      this.responseStatus = response && response.statusCode;
      if (response.statusCode === 200) {
        this.emailSent = true;
      } else {
        this.emailFailed = true;
      }
      this.isSendingMail = false;
    }
  },
  mounted() {
    this.resize();
  }
};
</script>
<style scoped>
.no-borders {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  border: 0;
  padding: 0;
}

.cursor-pointer {
  cursor: pointer;
}

input,
textarea {
  color: #525f7f;
}

input:focus,
textarea:focus {
  outline: none;
}
</style>